import { Button, Popover } from '@bedrock/components';
import { ChevronDown } from '@bedrock/icons-react';
import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import styles from './index.less';
import { PopoverProps } from '@bedrock/components/lib/Popover';

const cx = classNames.bind(styles);

interface IProps {
  items: {
    label?: React.ReactNode;
    value?: React.ReactNode;
  }[];
  maxLines?: number;
  style?: React.CSSProperties;
  className?: string;
  popoverContentClassName?: string;
  popoverProps?: PopoverProps;
}

const MultipleLinesEllipsis = ({
  items,
  maxLines = 4,
  style,
  className,
  popoverContentClassName,
  popoverProps = {},
}: IProps) => {
  const showItems = useMemo(() => {
    if (items?.length && items.length > maxLines) {
      return items.slice(0, maxLines - 1);
    }
    return items;
  }, [items, maxLines]);

  const renderItem = (item: any) => {
    return <div className='one-rows-ellipsis'>
      {!!item?.label && <span className={cx('label')}>{item.label}：</span>}
      <span className={cx('value')} title={typeof item.value === 'string' ? item.value : undefined}>{item?.value}</span>
    </div>
  }

  if (!items?.length || !showItems?.length) {
    return null;
  }

  return (
    <div style={style} className={className}>
      {
        showItems.map((item) => {
          return renderItem(item);
        })
      }
      {
        items.length > maxLines && <div>
          <Popover
            placement='topLeft'
            {...popoverProps}
            content={
            <div className={cx('popover-content', popoverContentClassName)}>
              {
                items.map((item) => {
                  return renderItem(item)
                })
              }
            </div>
          }>
            <Button suffixIcon={<ChevronDown />} size='xxSmall'>
              +{items.length - showItems.length}
            </Button>
          </Popover>
        </div>
      }
    </div>
  )
}

export default MultipleLinesEllipsis;
